import { useEffect } from 'react';
import { useColorScheme } from '@mui/joy/styles';
import Switch from '@mui/joy/Switch';
import FormLabel from '@mui/joy/FormLabel';

/**
 * Light/dark mode toggle.
 *
 * IMPORTANT: this app uses TWO independent theming systems:
 *   1. MUI Joy's useColorScheme() — flips --joy-palette-* variables used
 *      by MUI components (Button, Switch, Card, etc).
 *   2. Plain CSS variables in tokens.css — flipped by [data-theme="dark"]
 *      on <html>, used by primitives.css (.navbar, .hero, .card, etc).
 *
 * MUI Joy's setMode() only updates system (1). To keep the entire app
 * (including all hand-rolled CSS) in sync, we also write data-theme on
 * <html> on every change. Without this, MUI components re-theme on
 * toggle but the navbar/hero/leaderboard background stay light.
 */
export default function ModeToggle() {
  const { mode, setMode } = useColorScheme();

  // Sync <html data-theme> with MUI's mode on mount + every change.
  useEffect(() => {
    const html = document.documentElement;
    if (mode === 'dark' || mode === 'light') {
      html.setAttribute('data-theme', mode);
    } else {
      // mode === 'system' (the default) — let the prefers-color-scheme
      // media query in tokens.css decide.
      html.removeAttribute('data-theme');
    }
  }, [mode]);

  const isDark = mode === 'dark';
  const label = isDark ? 'Turn light' : 'Turn dark';

  return (
    <div>
      <Switch
        variant="outlined"
        color="neutral"
        checked={isDark}
        onChange={(e) => setMode(e.target.checked ? 'dark' : 'light')}
        style={{ padding: '0%', position: 'relative' }}
      />
      <FormLabel>{label}</FormLabel>
    </div>
  );
}